/* src/app/vehicle/pages/vehicle-new/vehicle-new.component.scss */
/*# sourceMappingURL=vehicle-new.component.css.map */
